// extracted by mini-css-extract-plugin
module.exports = {"siteMain":"style_siteMain__3bo33"};